export class SessionData {
  public id: string|null = null
  public searchPhrase!: string
  public totalFound!: number
  public maxRelevance!: number
  // public wasSuggestClick!: boolean
  // public wasCategoryClick!: boolean
  // public wasPagingClick!: boolean
}
